import { Badge, Stack, Text } from '@backyard-ui/core';

import { type Shipment } from '@/infra/services/catalog/product/get-shipments/model';
import { formatPrice } from '@/utils/price/formatPrice';

import { ErrorDisclaimer } from '../../ErrorDisclaimer';
import { ModalityItem } from '../../ModalityItem';

import { Wrapper } from './Wrapper';

interface ItemProps {
  shopName: string;
  shipment?: Shipment;
}

export default function Item(props: Readonly<ItemProps>) {
  const { shopName, shipment } = props;

  if (!shipment) {
    return (
      <Wrapper shopName={shopName}>
        <div data-testid="error-disclaimer">
          <ErrorDisclaimer />
        </div>
      </Wrapper>
    );
  }

  const modalities = shipment.pickupInStore
    ? [shipment.pickupInStore, ...shipment.modalities]
    : shipment.modalities;

  return (
    <Wrapper shopName={shopName}>
      {modalities.map((modality, index) => (
        <div key={index} data-testid={`modality-item-${modality.type}`}>
          <Stack justify="space-between">
            <ModalityItem modality={modality} hideCost />

            {modality.cost === 0 ? (
              <Badge
                appearance="critical"
                UNSAFE_className="self-start whitespace-nowrap"
              >
                <span>Grátis</span>
              </Badge>
            ) : (
              <Text size="md" color="green-600" weight="bold">
                {formatPrice(modality.cost)}
              </Text>
            )}
          </Stack>
        </div>
      ))}
    </Wrapper>
  );
}
